import { createFileRoute } from '@tanstack/react-router';
import { FileDown, Filter, Search } from 'lucide-react';
import { Card } from '@/components/Card/Card';
import type {
  IRelatorioEtiquetasFilterOption,
  TRelatorioEtiquetasFilterType,
} from '@/types/relatorioEtiquetas';
import './etiquetas.css';

export const Route = createFileRoute('/_authenticated/relatorio/etiquetas/form')({
  component: RelatorioEtiquetasFormPage,
});

export interface IRelatorioEtiquetasFormProps {
  filterType: TRelatorioEtiquetasFilterType;
  selectedFilter: string;
  filterValues: IRelatorioEtiquetasFilterOption[];
  isLoadingFilters?: boolean;
  isSearching?: boolean;
  canExport?: boolean;
  onFilterTypeChange: (filterType: TRelatorioEtiquetasFilterType) => void;
  onSelectedFilterChange: (value: string) => void;
  onSearch: () => void;
  onExport: () => void;
}

function getFilterValueLabel(filterType: TRelatorioEtiquetasFilterType): string {
  if (filterType === 'pedido') return 'Pedido';
  return 'Período';
}

export function RelatorioEtiquetasForm({
  filterType,
  selectedFilter,
  filterValues,
  isLoadingFilters = false,
  isSearching = false,
  canExport = false,
  onFilterTypeChange,
  onSelectedFilterChange,
  onSearch,
  onExport,
}: IRelatorioEtiquetasFormProps) {
  return (
    <Card className="filter">
      <Card.Header>
        <div className="relatorio-etiquetas-filter-header">
          <Filter
            size={18}
            aria-hidden="true"
          />
          <h3>Filtros de Pesquisa</h3>
        </div>
      </Card.Header>

      <Card.Content className="filter-card__content">
        <div className="relatorio-etiquetas-filters-grid">
          <div className="input-content">
            <label htmlFor="filter-type">Filtrar por</label>
            <select
              id="filter-type"
              value={filterType}
              onChange={(e) => onFilterTypeChange(e.target.value as TRelatorioEtiquetasFilterType)}
            >
              <option value="pedido">Pedido</option>
              <option value="saida">Data de Saída</option>
              <option value="entrada">Data de Entrada</option>
            </select>
          </div>

          <div className="input-content">
            <label htmlFor="filter-value">{getFilterValueLabel(filterType)}</label>
            <select
              id="filter-value"
              value={selectedFilter}
              onChange={(e) => onSelectedFilterChange(e.target.value)}
              disabled={isLoadingFilters}
            >
              <option value="">
                {isLoadingFilters ? 'Carregando...' : 'Selecione...'}
              </option>
              {filterValues.map((item) => (
                <option
                  key={String(item.value)}
                  value={String(item.value)}
                >
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className="filter-button"
            onClick={onSearch}
            disabled={isSearching || !selectedFilter}
          >
            <Search
              size={16}
              aria-hidden="true"
            />
            {isSearching ? 'Buscando...' : 'Buscar Dados'}
          </button>

          <button
            type="button"
            className="export-button"
            onClick={onExport}
            disabled={!canExport}
          >
            <FileDown
              size={16}
              aria-hidden="true"
            />
            Exportar Excel
          </button>
        </div>
      </Card.Content>
    </Card>
  );
}

function RelatorioEtiquetasFormPage() {
  return (
    <div className="relatorio-etiquetas-container">
      <div className="relatorio-etiquetas-content">
        <p className="relatorio-etiquetas-message relatorio-etiquetas-message--info">
          Utilize a listagem principal para consultar e exportar os dados.
        </p>
      </div>
    </div>
  );
}
